import { createFileRoute } from '@tanstack/react-router';
import { BroadcastJourneysRouteView } from '@/pages/workspaces/broadcasts/broadcast/routing';

function BroadcastJourneysRoute() {
  const { broadcastId } = Route.useParams();
  return <BroadcastJourneysRouteView broadcastId={broadcastId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/journeys',
)({
  component: BroadcastJourneysRoute,
});
